import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import {  Localized } from '../../../../objects';
import { LiturgyType } from '../../services/liturgy-type.service';


@Component({
  selector: 'app-liturgy-type',
  templateUrl: './liturgy-type.component.html',
  styleUrls: ['./liturgy-type.component.css']
})
export class LiturgyTypeComponent implements OnInit {

  public data: LiturgyType[];
  public isLoading = false;

  constructor(
    public dialog: MatDialog,
    private apiSvc: ApiService
  ) { }

  ngOnInit() {
    this.loadElements();
  }

  private loadElements() {
    this.isLoading = true;
    this.apiSvc.get("api/LiturgyType/", null).subscribe(
      (data: LiturgyType[]) => {
        this.data = data;
        console.log(this.data);
        this.isLoading = false;
      },
      (err) => {
        console.log("error", err);
        this.isLoading = false;
      }
   );
  }

  public add() {
    // const dialogRef = this.dialog.open(ReligionBranchEditComponent, {});
  }

  public edit(obj: LiturgyType) {
    console.log(obj);
    // const dialogRef = this.dialog.open(ReligionBranchEditComponent, {});
  }

  public delete(obj) {
     alert("Delete");
  }

}
